import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

import {
  NEW_ID,
  TYPE_HERO,
  TYPE_INFO,
  TYPE_INFOGRAPHIC,
  TYPE_ACTIONS_INITIATIVES,
  TYPE_QUESTION,
} from '@/util/constants';
import { computed, onMounted, PropType, ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { Story } from '@/models/story.model';
import { useEvents, Event } from '@/services/events.composable';
import { StoriesActions, StoriesState } from '@/stores/stories.store';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import {
  DisplayType,
  StoryItem,
  categoryRules,
} from '@/models/story-item.model';
import HeroContentForm from '@/components/hero/HeroContentForm.vue';
import InfoContentForm from '@/components/info/InfoContentForm.vue';
import QuestionContentForm from '@/components/quiz/QuestionContentForm.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import InfoGraphicContentForm from '@/components/infographic/InfoGraphicContentForm.vue';
import ActionsInitiativesContentForm from '@/components/stories/ActionsInitiativesContentForm.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'StoryItemForm',
  props: {
  data: {
    type: Object as PropType<{ type: string; story: Story; value?: StoryItem }>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const types = [
  {
    title: 'Action',
    value: 'action',
  },
  {
    title: 'Info',
    value: 'info',
  },
  {
    title: 'Initiative',
    value: 'initiative',
  },
  {
    title: 'InfoGraphic',
    value: 'info-graphic',
  },
  {
    title: 'Hero',
    value: 'hero',
  },
  {
    title: 'Quiz Question',
    value: 'question',
  },
];

const store = useStore<ShiftCMSState & { ts: StoriesState }>();
const events = useEvents();

const valid = ref<boolean>(false);

const type = ref<string>(props.data.type);

const lastItem = props.data.story.items.length
  ? props.data.story.items[props.data.story.items.length - 1]
  : null;

const parentItem = lastItem;

const column = lastItem ? lastItem.column + 1 : 0;

const model = ref<StoryItem>({
  id: NEW_ID,
  story: props.data.story,
  parentItem,
  column,
  row: 0,
  displayType: DisplayType.Normal,
  actions: [],
  initiatives: [],
});

const action = computed<string>(() =>
  model.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveStoryItem = async () => {
  let success: boolean = false;

  if (valid.value) {
    if (model.value.id === NEW_ID) {
      success = await store.dispatch(StoriesActions.AddStoryItem, model.value);
    } else {
      success = await store.dispatch(
        StoriesActions.UpdateStoryItem,
        model.value,
      );
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved story item',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(StoriesActions.GetStories);
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: 'Failed to save story item',
      type: 'error',
    });
  }
};

const updateStoryContent = async () => {
  if (model.value.story === null && props.data.story) {
    Object.assign(model.value, { story: props.data.story });
  }
  if (props.data.value) {
    Object.assign(model.value, { ...props.data.value });
  }

  if (model.value.id === NEW_ID) {
    delete model.value.info;
    delete model.value.infoGraphic;
    delete model.value.question;
    delete model.value.hero;

    switch (type.value) {
      case TYPE_INFOGRAPHIC:
        Object.assign(model.value, {
          infoGraphic: { id: NEW_ID, title: '', description: '' },
        });
        break;
      case TYPE_INFO:
        Object.assign(model.value, {
          info: { id: NEW_ID, title: '', description: '' },
        });
        break;
      case TYPE_HERO:
        Object.assign(model.value, { hero: { id: NEW_ID, title: '' } });
        break;
      case TYPE_QUESTION:
        Object.assign(model.value, {
          question: { id: NEW_ID, title: '', answers: [] },
        });
        break;
      case TYPE_ACTIONS_INITIATIVES:
        Object.assign(model.value, {
          initiatives: [],
          actions: [],
        });
        break;
    }
  } else {
    const translated = await store.dispatch(
      StoriesActions.GetStoryItem,
      model.value.id,
    );
    Object.assign(model, translated);
  }
};

onMounted(() => {
  events.on(Event.LanguageChanged, updateStoryContent);

  updateStoryContent();
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, updateStoryContent);
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveStoryItem, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(action.value)) + " " + _toDisplayString(type.value) + " ", 1),
            _createVNode(CurrentLanguage)
          ]),
          _withDirectives(_createVNode(_component_v_select, {
            modelValue: type.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((type).value = $event)),
              updateStoryContent
            ],
            items: types,
            rules: _unref(categoryRules),
            label: "Type",
            required: ""
          }, null, 8, ["modelValue", "rules"]), [
            [_vShow, model.value.id === _unref(NEW_ID)]
          ]),
          (type.value === _unref(TYPE_INFOGRAPHIC) && model.value.infoGraphic)
            ? (_openBlock(), _createBlock(InfoGraphicContentForm, {
                key: 0,
                modelValue: model.value.infoGraphic,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.infoGraphic) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (type.value === _unref(TYPE_INFO) && model.value.info)
            ? (_openBlock(), _createBlock(InfoContentForm, {
                key: 1,
                modelValue: model.value.info,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.value.info) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (type.value === _unref(TYPE_HERO) && model.value.hero)
            ? (_openBlock(), _createBlock(HeroContentForm, {
                key: 2,
                modelValue: model.value.hero,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.value.hero) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (type.value === _unref(TYPE_QUESTION) && model.value.question)
            ? (_openBlock(), _createBlock(QuestionContentForm, {
                key: 3,
                modelValue: model.value.question,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((model.value.question) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (type.value === _unref(TYPE_ACTIONS_INITIATIVES))
            ? (_openBlock(), _createBlock(ActionsInitiativesContentForm, {
                key: 4,
                modelValue: model.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((model).value = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})